/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum PlaybackEvent {
  /**
   * This event is the first event fired when a user takes action to play content
   */
  PLAYBACK_REQUEST = 'playback_request',

  /** Player has prepared the content and is ready */
  PLAYBACK_PREPARED = 'playback_prepared',

  /** Playback session officially starts */
  PLAYBACK_START = 'playback_start',

  /** First frame is rendered */
  PLAYBACK_STARTED = 'playback_started',

  /** Playback is ongoing (periodic progress updates) */
  PLAYBACK_INPROGRESS = 'playback_inprogress',

  /** Playback reaches the natural end of content */
  PLAYBACK_COMPLETE = 'playback_complete',

  /**
   * This event used to report when content playback ends.
   */
  PLAYBACK_END = 'playback_end',

  /** Playback is stopped before completion */
  PLAYBACK_STOPPED = 'playback_stopped',

  /** User/application pauses playback */
  PLAYBACK_PAUSED = 'playback_paused',

  /** Playback resumes after pause */
  PLAYBACK_RESUMED = 'playback_resumed',

  /** Buffering begins (network/seek stall) */
  PLAYBACK_BUFFERING_START = 'playback_buffering_start',

  /** Buffering ends and playback resumes */
  PLAYBACK_BUFFERING_END = 'playback_buffering_end',

  /** User or app initiates seeking */
  PLAYBACK_SEEK_START = 'playback_seek_start',

  /** Seek operation completes */
  PLAYBACK_SEEK_COMPLETE = 'playback_seek_complete',

  /** Playback variant (quality/bitrate) changes */
  PLAYBACK_VARIANT_CHANGE = 'playback_variant_change',

  /** User changes audio language */
  PLAYBACK_AUDIO_LANGUAGE_CHANGE = 'playback_audio_language_change',

  /** User changes subtitle language */
  PLAYBACK_SUBTITLE_LANGUAGE_CHANGE = 'playback_subtitle_language_change',

  /** User sends app to background */
  PLAYBACK_USER_WAIT_START = 'playback_user_wait_start',

  /** User returns app to foreground */
  PLAYBACK_USER_WAIT_END = 'playback_user_wait_end',

  /** This event is used to report playback metrics. */
  PLAYBACK_METRIC = 'playback_metric',
  /**
   * This event is fired if an error occurs during content playback or retrieval of the video.
   */
  PLAYBACK_ERROR = 'playback_error',

  /** Engagement score update */
  PLAYBACK_SUMMARY = 'playback_summary',
}
